<!-- Zone 1 redesign (29/10/2026): icon, title and version on one compact
     header, the legal text in a readable card, and the consent with its button
     in a footer that stays put with a shadow, so the member always sees what
     is asked of them while they scroll. -->
<ion-content class="ion-padding">
  <div class="legal-head">
    <div class="legal-head__icon">
      <span class="material-symbols-outlined">{{ words.icon }}</span>
    </div>
    <div class="legal-head__text">
      <h1 class="legal-head__title">{{ words.title | translate }}</h1>
      @if (version) {
      <span class="legal-head__version">{{ 'LEGAL_TEXT_UPDATE.VERSION' | translate : { version: version } }}</span>
      }
    </div>
  </div>
  <p class="legal-intro">{{ words.introduction | translate }}</p>

  @if (failedToLoad) {
  <p class="text-sm load-failed" style="color: var(--ion-color-danger)">
    {{ 'LEGAL_TEXT_UPDATE.LOAD_FAILED' | translate }}
  </p>
  } @else {
  <div class="policy-html" [innerHTML]="policyHtml"></div>
  }
</ion-content>

@if (failedToLoad) {
<div class="ion-padding">
  <ion-button class="w-full text-base later" (click)="later()">
    {{ 'LEGAL_TEXT_UPDATE.LATER' | translate }}
  </ion-button>
</div>
} @else {
<div class="legal-footer">
  <ion-item lines="none" class="checkbox-item">
    <ion-checkbox slot="start" [(ngModel)]="ticked" [disabled]="!policyHtml"></ion-checkbox>
    <ion-label>{{ words.checkbox | translate }}</ion-label>
  </ion-item>

  @if (submitFailed) {
  <div class="ion-padding-horizontal text-sm" style="color: var(--ion-color-danger)">
    {{ 'TERMS_POLICY_PAGE.ACCEPT_FAILED' | translate }}
  </div>
  }

  <div class="legal-footer__button">
    <ion-button [disabled]="!ticked || loading" class="w-full text-base submit" (click)="onSubmit()">
      {{ words.button | translate }}
    </ion-button>
  </div>
</div>
}
